$(document).ready(function () {
    $('.balz-gallery-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    autoplaySpeed: 2000,
                    Speed: 1000
                }
            }
        ]
    });

    $('.balz-labels-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
         responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
    
    $('#shopify-section-home_product_list_wL7dTq #balz-product-list .product-list .products').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    autoplaySpeed: 3500,
                    Speed: 2000,
                    vertical: true,
                    verticalScrolling: true,
                    verticalSwiping: true
                }
            }
        ]
    });
    
    // Clone Currency and add to Footer
    $(".site-header__links.dt-sc-flex form#currency_form").clone().appendTo(".site-footer__top .footer__item--menu_LYGExe.footer-links .text-start");
  
    if (window.innerWidth > 768) {
        // Search Icon Clone the element and prepend it as the first child of the target element
        $(".site-header__links.dt-sc-flex a.site-header__search_icon.dT_TopStickySearchBtn")
            .prependTo(".dt-sc-header-logo-sec #AccessibleNav");

        // Search Icon Clone the element and prepend it as the first child of the target element
        $(".site-header__links.dt-sc-flex form#currency_form")
            .appendTo(".dt-sc-header-logo-sec #AccessibleNav");
      
        // Search Icon Clone the element and prepend it as the first child of the target element
        $(".site-header__links.dt-sc-flex a#cart-number")
            .appendTo(".dt-sc-header-logo-sec #AccessibleNav");
    }

    // Select and move the social icons to a new location
    $(".site-footer__top .footer__item--social_48F6TB.footer-social")
        .insertAfter(".footer__item--menu_LYGExe.footer-links > .text-start");
  
    //Canadian Owned Logo Append to footer currency
    $(".footer__item--html_fQYRdq.footer-html")
        .appendTo(".footer__item--21ea0c66-a6e0-4431-96f1-672193b7043e.footer-newsletter");
    
    // Home Product Section button
    $(".row.home-products-row .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.home-products-row");

    // Logo Product Section button
    $(".row.our-logo-products .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.our-logo-products");

    //FAQS
    // Select all the questions
    $('.dt-sc-accordion-btn').each(function () {
      var $question = $(this); // Current question
      var $answer = $question.next('.dt-sc-accordion-content'); // Corresponding answer
      
      // Wrap the question and answer in a group div
      $question.add($answer).wrapAll('<div class="faq-group"></div>');
    });

    $('#faqs h5.active').each(function () {
      // Add a class to the direct parent of the h5
      $(this).closest('.dt-sc-accordion-btn').addClass('active-parent');
    });

    // $('#faqs .dt-sc-accordion-btn').on('click', function () {
    //   // Remove the class from all buttons
    //   $('.dt-sc-accordion-btn').removeClass('active-parent');
      
    //   // Add the class only to the clicked button
    //   $(this).addClass('active-parent');
    // });

    $('#faqs .dt-sc-accordion-btn').click(function() {
        
        var content = $(this).next('.dt-sc-accordion-content');
        // Toggle the active class on the clicked button
        $(this).toggleClass('active-parent');

        // Delay execution to ensure other scripts finish running first
        setTimeout(() => {
            $('#faqs .dt-sc-accordion-btn.active-parent h5').addClass("active");
            var h5Element = $(this).closest('.faq-group').find('h5');
            
            if ($(this).hasClass('active-parent')) {
                h5Element.addClass('active');
                $(this).closest('.faq-group').addClass("active");
            } else {
                h5Element.removeClass('active');
                $(this).closest('.faq-group').removeClass("active");

            }
        }, 10); // Adjust delay if needed
    });

    //Group Faqs into five Enablers page
     // Wrap the first five elements in a new container
    $('#shopify-section-page-enablers-faq-block .faq-group:nth-child(-n+6)').wrapAll('<div class="faq-group-1"></div>');
    // Wrap the remaining elements in another container
    $('#shopify-section-page-enablers-faq-block .dt-sc-accordion-container > .faq-group:nth-child(n+1)').wrapAll('<div class="faq-group-2"></div>');
   
    //Faqs Support page 
    // Wrap the first five elements in a new container
    $('#shopify-section-home-faq-block .faq-group:nth-child(-n+6)').wrapAll('<div class="faq-group-1"></div>');
    // Wrap the remaining elements in another container
    $('#shopify-section-home-faq-block .dt-sc-accordion-container > .faq-group:nth-child(n+1)').wrapAll('<div class="faq-group-2"></div>');

    //Enablers Page
    //Testimonial button
    $(".row.enablers-testimonials .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.enablers-testimonials");
    //Blog list button
    $(".row.balz-blog-list .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.balz-blog-list");
    //Enablers IG button
    $(".row.enablers-ig .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.enablers-ig");
    //Enablers FAQ btn
    $(".row.the-enables-faqs > .dt-sc-faqs .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.the-enables-faqs > .dt-sc-faqs");

    //On Tap Collections
    //Giftcards btn 
    $(".row.ontop-giftcards .dt-sc-heading a.dt-sc-btn")
        .appendTo(".row.ontop-giftcards");
    //Labels slider
    $(".balz-labels-slider.beer-labels")
        .appendTo("#shopify-section-on-tap-grid-banner-3 .content-content_TnMtY3 .dt-sc-grid-banner-image");
  
    $(".balz-labels-slider.cider-labels")
        .appendTo("#shopify-section-on-tap-grid-banner-3 .content-content_DFAWFh .dt-sc-grid-banner-image");

    //Product List 
    setTimeout(function() {
    $("#shopify-section-product-recommendations .grid-item .products .ImageWrapper .product-button.icon-bottom").each(function() {
            var button = $(this);
            button.appendTo(button.closest(".products"));
        });
    }, 1000); // Adjust the delay (1000ms = 1 second)

  
     $("#related-related-products-slider .grid-item .products .ImageWrapper .product-button.icon-bottom").each(function() {
            var button = $(this);
            button.appendTo(button.closest(".products"));
    });
    
  
    function moveButtons() {
        $(".product-collection .grid-item .products .ImageWrapper .product-button.icon-bottom").each(function() {
            var button = $(this);
            button.appendTo(button.closest(".products"));
        });
    }

    // Run on initial page load
    moveButtons();

    // 🛠️ Detect AJAX product loads (works with many Shopify themes)
    $(document).on("ajaxStop", function() {
        setTimeout(moveButtons, 500); // Small delay to let products load
    });

    // 🛠️ Detect "Load More" button clicks
    $(document).on("click", ".dT_VProdWrapper .pagination a", function() {
        setTimeout(moveButtons, 1500); // Give extra time for new items to load
    });

    // 🛠️ Use MutationObserver (for themes that use JavaScript DOM updates)
    const observer = new MutationObserver(function() {
        moveButtons();
    });

    // Watch for product list changes
    const target = document.querySelector(".product-collection");
    if (target) {
        observer.observe(target, { childList: true, subtree: true });
    }
  
});


setTimeout(function() {
  jQuery(document).ready(function($) {
    // Click on the menu trigger
      $('.dt-header-menu .menu-trigger').on('click', function() {
          $('body.iti-mobile, body > .mobile-menu').addClass('nav-is-visible');
          $('body > .mobile-menu-overlay').addClass('is-visible');
  
          // Add inline CSS to ensure visibility
          $('.mobile-menu').css({
              'display': 'block',
              'opacity': '1',
              'visibility': 'visible',
              'transform' : 'translateX(0px)',
              'animation-name' : 'dt-anime-slidein-right',
              'animation-duration' : '0.75s',
              'animation-fill-mode': 'both'
          });
          $('.mobile-menu-overlay').css({
              'opacity': '1',
              'visibility': 'visible'
          });
      });
  
      // Click on overlay or close button to remove classes and hide menu
      $('body').on('click', '.mobile-menu-overlay, .dt-desktop-menu .close-nav', function() {
          // Hide menu properly
          $('.mobile-menu').css({
              'display': 'none',
              'opacity': '0',
              'visibility': 'hidden'
          });
          $('.mobile-menu-overlay').css({
              'opacity': '0',
              'visibility': 'hidden'
          });
      });
  });
}, 500);
